export default {
    state() {
        return window.user;
    },
};
